import { Layout } from 'antd'
import React from 'react'

import BannerNotification from './BannerNotification'
import Navbar from './Navbar'
import NotificationBar from './NotificationBar'
import Search from './Search'
import styles from './styles'

const { Content } = Layout

const withLayout = Component => props =>
  (
    <Layout style={styles.container}>
      <BannerNotification />
      <NotificationBar />
      <Layout>
        <Navbar />
        <Content style={styles.content}>
          <Search />
          <Component {...props} />
        </Content>
      </Layout>
    </Layout>
  )

export default withLayout
